module.exports = __webpack_public_path__ + "assets/fonts/Gotham-Light.501537e6.otf";